// extracted by mini-css-extract-plugin
export default {"title":"applications-components-common-ProductDescription-description-module__title","text":"applications-components-common-ProductDescription-description-module__text","root":"applications-components-common-ProductDescription-description-module__root"};
    if(module.hot) {
      // 1791528100358
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  